export default function UnitOfMeasureRenderer(unitOfMeasure) {
    const unitOfMeasureMapping = {
        UNITS: "un.",
        KG: "kg."
    };

    return unitOfMeasureMapping[unitOfMeasure] || ""
}
